import { styled } from '../../utils/styled';

const LAUNCHER_SIZE = 48;
const LAUNCHER_EDGE_OFFSET = 21;
const LAUNCHER_BOTTOM_OFFSET_DESKTOP = 90;
const LAUNCHER_BOTTOM_OFFSET_MOBILE = 47;

export const StyledLauncher = styled('button')(({ theme }) => ({
  position: 'fixed',
  bottom: `${LAUNCHER_BOTTOM_OFFSET_DESKTOP}px`,
  right: `${LAUNCHER_EDGE_OFFSET}px`,
  width: `${LAUNCHER_SIZE}px`,
  height: `${LAUNCHER_SIZE}px`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  color: theme.palette.common.white,
  backgroundColor: theme.palette.blue[600],
  boxShadow: theme.boxShadows.menu,
  transition: 'transform 0.15s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  },
  [theme.breakpoints.down('md')]: {
    bottom: `${LAUNCHER_BOTTOM_OFFSET_MOBILE}px`,
    left: `${LAUNCHER_EDGE_OFFSET}px`,
    right: 'auto',
  },
}));
